
let InfoTab = require('app/restaurant/show/InfoTab');
let SepaTab = require('app/restaurant/show/SepaTab');
let AnalyseTab = require('app/restaurant/show/AnalyseTab');
let UserTab = require('app/restaurant/show/UserTab');
let SupplierTab = require('app/restaurant/show/SupplierTab');
let BookmarkTab = require('app/restaurant/show/BookmarkTab');
//let CopyTab = require('app/restaurant/show/CopyTab');
let StatTab = require('app/restaurant/show/StatTab');
let TrameTab = require('app/restaurant/show/TrameTab');


class ShowView {
    defaultOptions() {
        return {
            'activeTab': 'info',
            'selector': '.view-restaurant-show',
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);


        this.onTabChange = this.onTabChange.bind(this);

        this.$container = $(this.settings.selector);
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }


        this.initialize();
    }

    initialize() {
        var self = this;

        $('button[data-bs-toggle="tab"]',this.$container)
        .on('shown.bs.tab',this.onTabChange);

        this.loadTab(this.settings.activeTab);
    }

    onTabChange(event){

        let $shownTabBtn = $(event.target);
        let $previousShownTabBtn = $(event.relatedTarget);

        let shownTab = $shownTabBtn.data('tab');
        let previousShownTab = $previousShownTabBtn.data('tab');

        this.clearTab(previousShownTab);
        this.loadTab(shownTab);
    }

    clearTab(tab){
        let $tabBody = $('.'+tab+'-body',this.$container);

        $tabBody.html('');
    }

    loadTab(tab){
        let $tabBody = $('.'+tab+'-body',this.$container);

        $tabBody.html('')
        .append(window.App.generateLoader());

        window.setUrlParameter('tab',tab);

        switch(tab){
            case 'info':
                let infoTab = new InfoTab({
                    'restaurant': this.settings.restaurant,
                    '$container': $tabBody
                });
            break;
            case 'sepa':
                let sepaTab = new SepaTab({
                    'restaurant': this.settings.restaurant,
                    '$container': $tabBody
                });
            break;
            case 'analyse':
                let tabTab = new AnalyseTab({
                    'restaurant': this.settings.restaurant,
                    '$container': $tabBody
                });
            break;
            case 'user':
                let userTab = new UserTab({
                    'restaurant': this.settings.restaurant,
                    '$container': $tabBody
                });
            break;
            case 'supplier':
                let supplierTab = new SupplierTab({
                    'restaurant': this.settings.restaurant,
                    '$container': $tabBody
                });
            break;
            case 'bookmark':
                let bookmarkTab = new BookmarkTab({
                    'restaurant': this.settings.restaurant,
                    '$container': $tabBody
                });
            break;
            case 'stat':
                let statTab = new StatTab({
                    'restaurant': this.settings.restaurant,
                    '$container': $tabBody
                });
            break;
            case 'trame':
                let trameTab = new TrameTab({
                    'restaurant': this.settings.restaurant,
                    '$container': $tabBody
                });
            break;
        }
    }

}

module.exports = ShowView;

